interface BarData {
  label: string;
  value: number;
}

interface HorizontalBarChartProps {
  data: BarData[];
  colors?: string[];
  maxValue?: number;
}

export const MarketsBarChart = ({
  data,
  colors,
  maxValue,
}: HorizontalBarChartProps) => {
  const max = maxValue || Math.max(...data.map((d) => d.value));
  const defaultColors = [
    "hsl(var(--chart-1))",
    "hsl(var(--chart-2))",
    "hsl(var(--chart-3))",
    "hsl(var(--chart-4))",
  ];

  return (
    <div className="w-full space-y-2">
      {data.map((item, index) => {
        const percentage = item.value ? (item.value / max) * 100 : 0;
        const color =
          colors?.[index] || defaultColors[index % defaultColors.length];
        const isClass =
          typeof color === "string" &&
          !color.includes("(") &&
          !color.startsWith("#") &&
          !color.startsWith("var(");

        return (
          <div key={index} className="flex items-center gap-4">
            <div className="w-12 text-left font-semibold text-sm color-text-primary">
              {item.label}
            </div>
            <div
              className="flex-1 relative h-4  bg-muted/30 overflow-hidden"
              style={{ borderRadius: "0px 5px 5px 0px" }}
            >
              <div
                className={`h-full  transition-all duration-500 ease-out ${
                  isClass ? String(color) : ""
                }`}
                style={{
                  width: `${percentage}%`,
                  height: "100%",
                  ...(isClass ? {} : { backgroundColor: color as string }),
                  borderRadius: "0px 5px 5px 0px",
                }}
              />
              {color}
            </div>
            <div className="w-12 text-left font-semibold  text-sm">
              {item.value}
            </div>
          </div>
        );
      })}
    </div>
  );
};
